import React, { Component } from 'react';
import { connect } from 'react-redux';
import { resolveLocalizedText } from '../../../../utils';
import { ChangeContactView } from '../../components/ChangeContactView';
import {
  getChangeEmailLabels,
  getChangeEmailStepContext,
  getNewEmail,
} from '../../selectors/changeEmailSelector';
import {
  INIT_VERIFY_ERROR_CODE,
  verifyCode,
} from '../../actions/changeContactAction';
import {
  resendEmailOtp,
  submitChangeEmailForm,
} from '../../actions/changeEmailAction';
import './style.scss';
import { goto } from '../../../../actions/historyActions';
import VerificationCode from '../../../../components/VerificaionCode';
import {
  getChangeContactErrorCode,
  getSelectedPolicy,
  getChangeContactPolicyCardsLength,
} from '../../selectors/changeContactSelector';
import { getIsLoading } from '../../selectors/changeEmailSelector';
import { getVerifyLoading } from '../../selectors/changeContactSelector';
import {
  TrackUpdateContactSuccessContent,
  TrackUpdateContactSuccessAction,
  trackUpdateContactSuccess,
} from '../../../../utils/generalGaEventAnalytics';
import _ from 'lodash';
import LongLoadingView from '../../../../components/LongLoadingView';
import { POLICIES } from '../../constants/constants';
import EmmaErrorModal from '../../../../components/EmmaErrorModal';
import {
  UPDATE_EMAIL_FEATURE_ID,
  UPDATE_MAIL_NUMBER_OR_MOBILE_DEFAULT_ERROR_CODE,
} from '../../constants/constants';
import { getErrorCode, getErrorCodeFieldLabel } from '../../utils';
import { t } from '../../../../locales';

/**
 * isUpdate - true if selected policy's existing email address is not empty.
 */
export interface ChangeEmailVerifyContainerProps {
  onSubmitChangeEmailForm: (otp: string) => any;
  onVerifyCode: (code: string, callback: () => void) => void;
  onResendCode: () => any;
  changeEmailLabels: any;
  changeEmailStepContext: any;
  isUpdate: boolean;
  selectedPolicy: any;
  init: () => void;
  errorMsg: string;
  isLoading: boolean;
  policies: number;
  newEmail: string;
}

export interface ChangeEmailVerifyContainerState {}

export class ChangeEmailVerifyContainer extends Component<
  ChangeEmailVerifyContainerProps,
  ChangeEmailVerifyContainerState
> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  onValidate = (value: string) => {
    const { onSubmitChangeEmailForm, onVerifyCode, isUpdate } = this.props;

    onVerifyCode(value, () => {
      onSubmitChangeEmailForm(value);
    });
  };

  onReSend = () => {
    const { onResendCode } = this.props;

    onResendCode();
  };

  componentDidMount() {
    this.props.init();
    const { selectedPolicy } = this.props;
    if (_.isEmpty(selectedPolicy)) {
      goto('emma-change-contact', undefined, undefined, true);
    }
  }

  render() {
    const {
      changeEmailLabels,
      changeEmailStepContext,
      isLoading,
      policies,
      errorMsg,
      newEmail,
    } = this.props;
    const editEmail = resolveLocalizedText(changeEmailLabels.editEmail);
    const resolvedStepContext = resolveLocalizedText(
      changeEmailStepContext,
    ) as any;
    return (
      <div className="Change-Email-Verifiy">
        <ChangeContactView
          pageName={editEmail}
          stepContext={resolvedStepContext}
          activeIndex={2}
        >
          {isLoading ? (
            <LongLoadingView isShowText={policies > POLICIES} />
          ) : (
            <div className="emma-stylesheet-grid-system">
              <VerificationCode
                newContact={newEmail}
                onReSend={this.onReSend}
                onValidate={this.onValidate}
                errorMsg={errorMsg}
                text={t('OTP_EMAIL_TEXT')}
              />
            </div>
          )}
        </ChangeContactView>
        <EmmaErrorModal />
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    const changeEmailLabels = getChangeEmailLabels(state);
    const changeEmailStepContext = getChangeEmailStepContext(state);
    const selectedPolicy = getSelectedPolicy(state);
    const verifyErrorCode = getChangeContactErrorCode(state);
    let errorMsg = '';
    if (verifyErrorCode != '') {
      const errorCode = getErrorCode(verifyErrorCode, state);
      errorMsg = getErrorCodeFieldLabel(errorCode, 'title');
    }
    const isLoading = getIsLoading(state);
    const isVerifyLoading = getVerifyLoading(state);

    const policies = getChangeContactPolicyCardsLength(state);

    const newEmail = getNewEmail(state);

    return {
      changeEmailLabels,
      changeEmailStepContext,
      isUpdate: !!selectedPolicy.emailText,
      selectedPolicy,
      errorMsg,
      isLoading: isVerifyLoading || isLoading,
      policies,
      newEmail,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    const defaultErrorCode = UPDATE_MAIL_NUMBER_OR_MOBILE_DEFAULT_ERROR_CODE;
    return {
      onSubmitChangeEmailForm: (otp: string) =>
        dispatch(
          submitChangeEmailForm({
            otp,
            defaultErrorCode,
            featureId: UPDATE_EMAIL_FEATURE_ID,
          }),
        ),
      onVerifyCode: (otp: string, callback: () => void) =>
        dispatch(
          verifyCode({
            featureName: 'updateEmail',
            otp,
            defaultErrorCode,
            callback,
            featureId: UPDATE_EMAIL_FEATURE_ID,
          }),
        ),
      onResendCode: () => {
        dispatch(resendEmailOtp());
        dispatch({ type: INIT_VERIFY_ERROR_CODE });
      },
      init: () => dispatch({ type: INIT_VERIFY_ERROR_CODE }),
    };
  }
}

export default connect(
  ChangeEmailVerifyContainer.mapStateToProps,
  ChangeEmailVerifyContainer.mapDispatchToProps,
)(ChangeEmailVerifyContainer);
